<template>
  <div>
    <div slot="header"></div>
    <div>
      <vs-alert title="Erro no processo" color="danger" v-if="error">
        {{ error }}
      </vs-alert>
    </div>
    <div style="margin-top: 15px">
      <vs-textarea
        rows="7"
        v-model="reasonDivergence"
        height="10rem"
        label="Descreva o Motivo de Divergência"
      />
      <vs-button
        icon="check"
        :disabled="!this.reasonDivergence"
        style="width: 100%"
        @click="openAlert()"
      >
        Avançar Etapa
      </vs-button>
    </div>
  </div>
</template>

<script>
import PreRegistrationService from "../services/preRegistration.js";
import Mailing from "../services/mailing";
import {
  notifySuccess,
  getStepsInformation,
  getLoginDataFromStorage,
} from "../helpers";

export default {
  name: "ReasonsCancel",
  data: () => ({
    userData: "",
    reasonDivergence: null,
    pre: null,
    error: null,
  }),

  created() {
    this.userData = getLoginDataFromStorage();
    const stepsData = getStepsInformation();
    const preRegistrationId = stepsData.preRegistrationId;

    this.$vs.loading();
    new PreRegistrationService()
      .getPreRegistration(1, preRegistrationId)
      .then((res) => {
        this.pre = res.data;
      })
      .catch(() => {
        this.$vs.loading.close();
      });
  },
  methods: {
    openAlert() {
      this.$vs.dialog({
        color: "danger",
        title: "Confirmação",
        text: "Confirma o avanço de etapa",
        type: "confirm",
        accept: this.acceptAlert,
      });
    },
    acceptAlert() {
      this.$vs.loading();
      const payloadParams = {
        CODLOCAL: this.pre.CODLOCAL,
        CODCOLIGADA: this.pre.CODCOLIGADA,
        CODATENDIMENTO: this.pre.CODATENDIMENTO,
        CODCOLIGADARESP: this.pre.CODCOLIGADAATENDENTERESP,
        CODATENDENTERESP: this.pre.CODATENDENTERESP,
        PARAMETRO_229: this.reasonDivergence,
      };

      new Mailing()
        .updateParamsAttendance(payloadParams)
        .then(() => {
          const payloadStep = {
            CODCOLIGADA: this.pre.CODCOLIGADA,
            CODLOCAL: this.pre.CODLOCAL,
            CODATENDIMENTO: this.pre.CODATENDIMENTO,
            CODTIPOATENDIMENTO: this.pre.CODTIPOATENDIMENTO,
            ID: this.pre.IDPREMATRICULA,
            CODUSUARIO: this.userData.username,
          };

          new PreRegistrationService()
            .divergenceStage(payloadStep)
            .then(() => {
              notifySuccess(
                this,
                "Motivo de Divergência editado com sucesso!"
              );
              this.$router.push("/audits");
            })
            .catch((error) => {
              this.error = error.response.data.error;
            })
            .finally(() => {
              this.$vs.loading.close();
            });
        })
        .catch((error) => {
          this.error =
            "Erro ao alterar o motivo de divergência: " +
            error.response.data.error;
          this.$vs.loading.close();
        });
    },
  },
};
</script>
